module.exports = __webpack_public_path__ + "img/store-3-fill.7b1be009.svg";